// extracted by mini-css-extract-plugin
export var cardLayout = "_73-1";
export var paginationContainer = "_73-0";